/**
 * Created by fers on 22/01/2017.
 */
/* global global */

import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, IntlShape} from 'react-intl';
import MiniLogo from '../app/MiniLogo.react';
import LargeLogo from '../app/LargeLogo.react';
import DocumentTitle from 'react-document-title';

import './LoadingLine.scss';

/* eslint react/jsx-sort-props: 0 */

export function isPanelInjected() {
    if (global && global.buffer) {
        return false;
    }

    try {
        if (window['config'] && window['config']['isInjected']) {
            switch (typeof window['config']['isInjected']) {
                case "boolean":
                    return window['config']['isInjected'];
                case "string":
                    return window['config']['isInjected'] === "true";
                default:
                    return Boolean(window['config']['isInjected']);
            }
        }
    }
    catch (e) {
        // do nothing
    }

    return false;
}

let loadingInstance = null;
let loadingInstanceMounted = false;
let loadingInterval = null;

interface LoadingLineProps {
 children?: React.ReactNode;
 inPanel?: boolean;
 stopped?: boolean;
 withMessage?: boolean;
}

// TODO multiple instances of loading line in one time

export class LoadingLine extends React.Component<LoadingLineProps> {

    static propTypes = {
        children: PropTypes.node,
        inPanel: PropTypes.bool,
        stopped: PropTypes.bool,
        withMessage: PropTypes.bool,
    };

    static defaultProps = {
        asMessage: false,
        inPanel: false,
    };

    constructor() {
        super();

        this.state = {
            progress: 0,
            visibility: true
        };

        loadingInstance = this; // eslint-disable-line consistent-this

        this.stoppingTimeout = null;
    }

    componentDidMount() {
        loadingInstanceMounted = true;

        clearInterval(loadingInterval);

        if (!this.props.stopped) {
            LoadingLine.start();
        }
    }

    componentWillUnmount() {
        loadingInstanceMounted = false;

        if (window && window.Dativery && window.Dativery.stopLoading) {
            window.Dativery.stopLoading();
            return;
        }
        this.setState({
            progress: 100000000
        });
        clearInterval(loadingInterval);
    }

    static progressToPercents(progress) {
        return 100 * (1 - Math.pow(progress, -0.4));
    }

    static start() {
        if (window && window.Dativery && window.Dativery.startLoading) {
            window.Dativery.startLoading();
            return;
        }

        if (loadingInstance && loadingInstanceMounted) {
            clearTimeout(loadingInstance.stoppingTimeout);
            setTimeout(() => {
                clearTimeout(loadingInterval);
                loadingInterval = setInterval(() => {
                    try {
                        // if (loadingInstance.__isMounted)  {
                            loadingInstance.setState({
                                progress: loadingInstance.state.progress + 1
                            });
                        // }
                        // else {
                        // 	clearTimeout(loadingInterval);
                        // }
                    }
                    catch (e) {
                        clearTimeout(loadingInterval);
                    }
                }, 100);

                if (loadingInstance.__isMounted)  {
                    loadingInstance.setState({
                        progress: 0,
                        visibility: true
                    });
                }
            }, 0);
        }
    }

    static stop() {
        if (window && window.Dativery && window.Dativery.stopLoading) {
            window.Dativery.stopLoading();
            return;
        }

        if (loadingInstance && loadingInstanceMounted) {
            loadingInstance.stoppingTimeout = setTimeout(() => {
                setTimeout(() => {
                    if (loadingInstanceMounted) { // the mounting can changed on timeout
                        loadingInstance.setState({
                            progress: 100000000
                        });
                    }
                }, 0);

                setTimeout(() => {
                    clearInterval(loadingInterval);
                    if (loadingInstanceMounted) { // the mounting can changed on timeout
                        loadingInstance.setState({
                            progress: 0,
                            visibility: false
                        });
                    }
                }, 100);
            }, 50);
        }
    }

    static exists() {
        return Boolean(loadingInstanceMounted);
    }

    render() {
        if (!global && window && window.Dativery && window.Dativery.startLoading) {
            window.Dativery.startLoading(null, this.props.withMessage ? this.props.children : false);
        }

        let loadingLineRender = (<div className={"loadingLine" + (isPanelInjected() ? " injected" : " normal") + (this.props.inPanel ? " inPanel" : "")} style={{width: LoadingLine.progressToPercents(this.state.progress) + '%', display: this.state.visibility ? 'block' : 'none'}}></div>);

        if (this.props.withMessage) {
            return (
                <center style={{position: 'relative'}}>
                    {loadingLineRender}
                    <p style={{fontSize: '18px', paddingTop: '16px'}}>
                        {this.props.children}
                    </p>
                </center>
            );
        }

        return loadingLineRender;
    }
}

let firstLoading = true;
export function renderLoadingPanel(args) {

    if (args && args.props) {
        return React.cloneElement(args.element, args.props);
    }

    if (firstLoading) {
        firstLoading = false;

        return (<center>
            <LoadingLine />
            <LargeLogo />
        </center>);
    }

    return (
        <DocumentTitle id="loadingScreen" title="Loading…">
            <center className="LoadingLineOffset" style={{position: "relative"}}>
                <LoadingLine />
                <h4 style={{marginTop: '0', paddingTop: '10px'}}>
                    <MiniLogo color width="150px"/><br />
                    <FormattedMessage defaultMessage="Loading data from server…" id="loadingDataFromServer" />
                </h4>
            </center>
        </DocumentTitle>
    );
}
